import React, { useState, useEffect } from "react";
import "./Proceso_Menu.scss";
import { Popover, Select, Icon } from "antd";
import axios from "axios";
import { ID_SISTEMA as idSistema } from "../../utils/constanst";
import useAuth from "../../hooks/useAuth";

const { Option } = Select;

export default function ProcesoMenu({ history }) {
  const url = `${localStorage.getItem("SERVERCENTRAL")}/cambiaInfoMenu`;
  const { user, setUser } = useAuth();
  const { user: usuario, idMunicipio, ambito, versionUsuario, infoMenu } = user;
  const { idEstado, idDistrito } = usuario;
  const rolUsuario = usuario.rol[0];
  var infoMenuGeografico = {
    infoMenu,
    idSistema,
    idEstado,
    idDistrito,
    idMunicipio,
    ambito,
    rolUsuario,
    versionUsuario,
  };
  const [infoMenuHook, setInfoMenuHook] = useState();
  const [tipoGeografico, setTipoGeografico] = useState();

  useEffect(() => {
    let x = 0;
    if (infoMenuGeografico.versionUsuario === "OC") {
      const existe = infoMenu.listaDetalles.find(
        (detalle) => detalle.descripcion === "TODOS-OC"
      );
      if (!existe) {
        infoMenu.listaDetalles.unshift({
          ambitoDetalle: "L",
          ambitoProceso: "L",
          ambitoSistema: "L",
          anio: 2025,
          casillaUnica: "",
          coincidenciaUsuarioSistema: "N",
          corte: 13,
          descripcion: "TODOS-OC",
          idDetalleProceso: 0,
          idEstado: 0,
          idProcesoElectoral: 27,
          nombreProceso: "Proceso Electoral Local 2024-2025",
          porSeccion: "N",
          tipoCapturaSistema: "D",
          tipoProceso: "O",
          vigente: "S",
        });
      }
    }
    let infoMenuAux = infoMenu;
    if (infoMenuAux) {
      let tipoGeo = obtieneTipoLista(infoMenuAux);
      setTipoGeografico(tipoGeo);
    }
    setInfoMenuHook(infoMenuAux);
  }, [infoMenu]);

  const seleccionaDetalle = async (detalleSelec) => {
    let infoMenu = {
      ...infoMenuHook,
    };
    infoMenu.detalleSelec = detalleSelec.key ? null : detalleSelec;
    infoMenu = limpiaNivelOC(infoMenu);
    // console.log("infoMenu", infoMenu);
    if (detalleSelec.descripcion === "TODOS-OC") {
      infoMenu.listaDetalles[0].idEstado = infoMenu.listaDetalles[1].idEstado;
      infoMenu.listaDetalles[0].idDetalleProceso =
        infoMenu.listaDetalles[1].idDetalleProceso;
    }
    //  console.log("infoMenu***", infoMenu);
    infoMenuGeografico.infoMenu = infoMenu;
    if (!detalleSelec.key) {
      infoMenuGeografico.tipoCambioGeografico = 1;
      //console.log("infoMenuGeografico", infoMenuGeografico);
      const response = await axios.post(url, infoMenuGeografico,{
        headers: {
            'Authorization': localStorage.getItem('accessToken'),
            'Content-Type': 'application/json',
            Accept: "application/json",
        }
    });
      
      infoMenu = response.data.infoMenu;
    }
    //console.log("INFOMENUF******", infoMenu);

    if (detalleSelec.descripcion === "TODOS-OC") {
      infoMenu.detalleSelec.idDetalleProceso = 0;
      infoMenu.detalleSelec.idEstado = 0;
      infoMenu.listaDetalles[0].idEstado = 0;
      infoMenu.listaDetalles[0].idDetalleProceso = 0;
      detalleSelec.idDetalleProceso = 0;
      infoMenu.listaEstados = null;
    }
    localStorage.setItem("INFO_MENU", JSON.stringify(infoMenu));
    
    //console.log("INFOMENUF1******", infoMenu);
    //console.log("INFOMENUdetalle******", detalleSelec);
    localStorage.setItem("DESCRIPCION", detalleSelec.descripcion);
    localStorage.setItem("ID_DETALLE_PROCESO", detalleSelec.idDetalleProceso);
    localStorage.setItem(
      "ID_PROCESO_ELECTORAL",
      detalleSelec.idProcesoElectoral
    );
    localStorage.setItem("ANIO", detalleSelec.anio);
    localStorage.setItem("TIPO_PROCESO", detalleSelec.tipoProceso);
    localStorage.setItem("ESTADO", "null");
    localStorage.setItem("ID_ESTADO_SELECCIONADO", "null");

    if(infoMenu.listaEstados && infoMenu.listaEstados.length === 1){
      //console.log("Entro aquí.......");
      let estadoSelec = infoMenu.listaEstados[0];
      infoMenu.estadoSelec = estadoSelec.key ? null : estadoSelec;
      localStorage.setItem("INFO_MENU", JSON.stringify(infoMenu));
      localStorage.setItem("ESTADO", estadoSelec.nombreEstado);
      localStorage.setItem("ID_ESTADO_SELECCIONADO", estadoSelec.idEstado);
    }

    setInfoMenuHook(infoMenu);
    setUser((user) => {
      return { ...user, infoMenu };
    });

    history.location.pathname !== "/home" && history.push("/home");
  };
  //console.log("LISTA INICIAL", localStorage.getItem("LISTA_DETALLES"));
  const seleccionaEstado = async (estadoSelec) => {
    let infoMenu = {
      ...infoMenuHook,
    };
    infoMenu.estadoSelec = estadoSelec.key ? null : estadoSelec;
    localStorage.setItem("INFO_MENU", JSON.stringify(infoMenu));
    setUser((user) => {
      return { ...user, infoMenu };
    });
    localStorage.setItem("ESTADO", estadoSelec.nombreEstado);
    localStorage.setItem("ID_ESTADO_SELECCIONADO", estadoSelec.idEstado);
    history.location.pathname !== "/home" && history.push("/home");
  };

  const limpiaNivelOC = (infoMenu) => {
    infoMenu = {
      ...infoMenu,
      estadoSelec: null,
      listaEstados: null,
      distritoFedSelec: null,
      listaDistritosFed: null,
      distritoLocSelec: null,
      listaDistritosLoc: null,
      municipioSelec: null,
      listaMunicipios: null,
      listMenu: null,
    };
    return infoMenu;
  };

  const obtieneTipoLista = (infoMenu) => {
    let tipoGeograficoAux;
    if (infoMenu) {
      if (infoMenu.listaDistritosFed) {
        tipoGeograficoAux = {
          nombreLista: "listaDistritosFed",
          nombreID: "idDistrito",
          nombreGeografia: "nombreDistrito",
          nombreSelect: "distritoFedSelec",
        };
      } else if (infoMenu.listaDistritosLoc) {
        tipoGeograficoAux = {
          nombreLista: "listaDistritosLoc",
          nombreID: "idDistrito",
          nombreGeografia: "nombreDistrito",
          nombreSelect: "distritoLocSelec",
        };
      } else if (infoMenu.listaMunicipios) {
        tipoGeograficoAux = {
          nombreLista: "listaMunicipios",
          nombreID: "idMunicipio",
          nombreGeografia: "nombreMunicipio",
          nombreSelect: "municipioSelec",
        };
      } else {
        tipoGeograficoAux = null;
      }
    }

    return tipoGeograficoAux;
  };

  function MenuUsuario() {
    //  console.log("Detalle",infoMenuHook.detalleSelec)
    //console.log("Detalle list",infoMenuHook.listaDetalles)
    return (
      <div>
        <div className="etiqueta">Proceso Electoral</div>
        <Select
          defaultValue={
            infoMenuHook && infoMenuHook.detalleSelec
              ? infoMenuHook.detalleSelec.descripcion
              : "Seleccionar"
          }
          style={{ width: 280 }}
          //disabled={!(versionUsuario === "OC")}
        >
          <Option value="-1" onClick={seleccionaDetalle}>
            {" "}
            Seleccionar{" "}
          </Option>
          {infoMenuHook &&
            infoMenuHook.listaDetalles &&
            infoMenuHook.listaDetalles.map((detalle, i) => (
              <Option onClick={seleccionaDetalle.bind(this, detalle)} key={i}>
                {detalle.descripcion}
              </Option>
            ))}
        </Select>
        <p> </p>

        <div className="etiqueta">Entidad</div>
        <Select
          defaultValue={
            infoMenuHook && infoMenuHook.estadoSelec
              ? infoMenuHook.estadoSelec.nombreEstado
              : "Selecciona"
          }
          style={{ width: 280 }}
          disabled={
            !(
              infoMenuHook &&
              infoMenuHook.listaEstados &&
              infoMenuHook.listaEstados > 1 &&
              versionUsuario === "OC"
            )
          }
        >
          {infoMenuHook && infoMenuHook.estadoSelec
            ? //  console.log("infoMenuHook.estadoSelec.idEstado:=>", infoMenuHook.estadoSelec.idEstado),
              (localStorage.setItem(
                "ESTADO",
                infoMenuHook.estadoSelec.nombreEstado
              ),
              localStorage.setItem(
                "ID_ESTADO_SELECCIONADO",
                infoMenuHook.estadoSelec.idEstado
              ))
            : (localStorage.setItem("ESTADO", null),
              localStorage.setItem("ID_ESTADO_SELECCIONADO", null))}
          <Option value="-1" onClick={seleccionaEstado}>
            {" "}
            Selecciona{" "}
          </Option>
          {infoMenuHook &&
            infoMenuHook.listaEstados &&
            infoMenuHook.listaEstados.map((estado) => (
              <Option
                onClick={seleccionaEstado.bind(this, estado)}
                key={estado.idEstado}
              >
                {estado.nombreEstado}
              </Option>

            ))}
        </Select>
      </div>
    );
  }

  const content = () => <MenuUsuario />;

  return (
    <div className="procesoContainer">
      <Popover
        content={content()}
        trigger={!(versionUsuario === "JD") ? "click" : ""}
        placement="bottomRight"
      >
        <div className="proceso">
          <div>
            <span>
              {infoMenuHook && infoMenuHook.detalleSelec ? (
                infoMenuHook.detalleSelec.descripcion
              ) : (
                <div>
                  {versionUsuario === "OC"
                    ? "OFICINAS CENTRALES"
                    : "PROCESO ELECTORAL"}
                </div>
              )}
            </span>
          </div>
          <div>
            <span>
              {infoMenuHook && infoMenuHook.estadoSelec && (
                <>
                  <Icon type="environment" theme="filled" />{" "}
                  {infoMenuHook.estadoSelec.nombreEstado}
                </>
              )}
            </span>
          </div>
        </div>
      </Popover>
    </div>
  );
}
